<template>
  <div class="flex flex-col h-screen w-screen overflow-hidden bg p-24" @touchstart="resetInactivityTimer"
  @keydown="resetInactivityTimer">
    <!-- Top Section -->
    <div class="flex flex-row justify-between">
      <div class="flex flex-row items-center justify-cente">
        <div @click="this.goBack()" class="bg-grey-lighter h-16 w-16 rounded-xl flex justify-center align-middle items-center text-3xl text-grey-darker font-semibold">
          <img :src="getIcon('back')" alt="">
        </div>
        <img :src="getImage('logo')" alt="Logo" class="w-1/5 ml-5" />
      </div>

      <div class="flex flex-row rounded-full text-3xl bg-grey-lighter">
        <!-- Tagalog Button -->
        <div @click="setLanguage('tl')"
          class="flex justify-center items-center w-48 ml-4 my-4 px-4 py-3 rounded-full cursor-pointer"
          :class="this.$i18n.locale === 'tl' ? 'bg-white font-medium text-grey-darkest border-2' : 'text-grey-dark'">
          Tagalog
        </div>

        <!-- English Button -->
        <div @click="setLanguage('en')"
          class="flex justify-center items-center w-48 mr-4 my-4 px-4 py-3 rounded-full cursor-pointer"
          :class="this.$i18n.locale === 'en' ? 'bg-white font-medium text-grey-darkest border-2' : 'text-grey-dark'">
          English
        </div>
      </div>
    </div>

    <!-- Main Content -->
    <div class="flex flex-grow mt-16 h-screen">
      <div class="w-1/4 h-full mr-16 bg-primary rounded-2xl bg-cover bg-center" 
      :style="{ backgroundImage: `url(${require('@/assets/images/papsi_sample.png')})` }"></div>

      <div class="w-3/4 h-full rounded-xl flex flex-col">
        <p class="text-primary uppercase text-6xl font-bold mb-10">Select a Service</p>
        <div class="papsi-grid h-full flex-grow grid grid-cols-2 gap-4">
          <TicketCardControl @click="this.$router.push({name: 'login-page'})">Check Account</TicketCardControl>
          <TicketCardControl @click="ticket_modal=true">Withdrawal/Updating</TicketCardControl>
          <TicketCardControl>Deposit/Direct Payment</TicketCardControl>
          <TicketCardControl>Loan</TicketCardControl>
          <TicketCardControl>Senior/PWD</TicketCardControl>
          <TicketCardControl>Membership Inquiries</TicketCardControl>
          <TicketCardControl>Bayad Connect</TicketCardControl>
          <TicketCardControl>Giveaway</TicketCardControl>
        </div>
      </div>
    </div>

    
    <transition name="slide-in">
      <ModalControl :is_visible="this.ticket_modal" is_qr>
        <div class="flex flex-col items-center align-middle px-10 text-center">
          <img :src="getIcon('check')">
          <p class="text-primary text-5xl font-bold my-5 uppercase">Ticket Successful</p>
          <p class="text-3xl mb-16 text-grey-darkest ">Claim your ticket and wait for the teller to call your number</p>
  
          <div
            class="bg-primary-light h-auto p-8 text-primary font-bold flex w-full items-center justify-center rounded-3xl"
            style="font-size: 7rem;">
            <p>W001</p>
          </div>
  
          <ButtonControl @click="ticket_modal = false" theme="success" text="Proceed" class="w-full" />
        </div>
      </ModalControl>
    </transition>
  </div>


</template>

<script>
import mixin from "@/mixins/controls.js";
import TicketCardControl from "@/components/controls/TicketCardControl.vue";
import ButtonControl from "@/components/controls/ButtonControl.vue";
import ModalControl from "@/components/controls/ModalControl.vue";

export default {
  name: "SelectServiceView",
  mixins: [mixin],
  inject: ['setLoading', 'setError'],
  data() {
    return {
      ticket_modal: false,
      inactivity_timeout: null,
    }
  },
  components: {
    TicketCardControl,
    ModalControl,
    ButtonControl
  },
  methods: {
    setLanguage(lang) {
      this.$store.commit('setLanguage', lang);
      this.$i18n.locale = lang;
    },
    resetInactivityTimer() {
      clearTimeout(this.inactivity_timeout);
      this.startInactivityTimer();
    },
    startInactivityTimer() {
      if (process.env.VUE_APP_DEVELOPMENT_MODE === 'false') {
        this.inactivity_timeout = setTimeout(() => {
        this.$router.push({ name: "start-page" });
        }, process.env.VUE_APP_IDLE_DELAY || 30000);
      } 
    },
  },
  mounted() {
    this.startInactivityTimer();
  },
  beforeUnmount() {
    clearTimeout(this.inactivity_timeout);
  },
};
</script>

<style scoped>
.papsi-error-screen {
  background: radial-gradient(circle, rgba(229, 231, 235, 1) 10%, rgb(149, 155, 167) 100%);
}

.papsi-logo {
  top: 100px;
  left: 50%;
  transform: translateX(-50%);
  width: 15rem;
}

.papsi-grid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: repeat(4, 1fr);
  /* Two columns */
  gap: 2rem;
}

  .bg {
    background: radial-gradient(circle, 
                rgb(236, 236, 236) 10%, 
                rgb(212, 212, 212) 100%);
  }
</style>